import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IHeaderParams } from 'ag-grid-community';

@Component({
    selector: "cxone-checkbox-header",
    templateUrl: "./cxone-checkbox-header.component.html",
    styleUrl: "./cxone-checkbox-header.component.scss",
})
export class CxoneCheckboxHeaderComponent implements IHeaderAngularComp {
    public checked: boolean = false;
    public indeterminate: boolean = false;
    public params: IHeaderParams;

    agInit(params: IHeaderParams): void {
        this.params = params;
        this.updateCheckboxState();
        this.params.api.addEventListener('selectionChanged', this.updateCheckboxState.bind(this));
    }
    
    refresh(params: IHeaderParams): boolean {
        this.params = params;
        this.updateCheckboxState();
        return true;
    }

    onCheckboxChange(event: any): void {
        const isChecked = event.checked;
        this.params.api.forEachNode(node => node.setSelected(isChecked));
        this.updateCheckboxState();
    }

    updateCheckboxState(): void {
        const allRows = this.params.api.getDisplayedRowCount();
        const selectedRows = this.params.api.getSelectedRows().length;
    
        this.checked = allRows > 0 && selectedRows === allRows;
        this.indeterminate = selectedRows > 0 && selectedRows < allRows;
    }
}

